<!-- eslint-disable -->
<template lang="pug">
    .play-box
        template(v-if="!isLoading")
            iframe.presentation(
                :src="presentationSrc"
                frameborder="0"
                allowfullscreen="true"
                mozallowfullscreen="true"
                webkitallowfullscreen="true"
            )
        .loading-box(v-else)
            | {{ $i18n.t('presentations.presentations_playBox_isLoading') }}
            cs-loader
        cs-button.play-box__button(
            pattern="primary-outline",
            @click="$router.push(toLink)"
        )
            | {{ toLinkText }}
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';
    import { cloneDeep } from "lodash";
    const DISABLE_TOOLBAR_FLAG = "#toolbar=0";

    export default {
        mounted () {
            if (this.paramsArray && this.paramsArray[0]) {
                this.parameters = cloneDeep(this.paramsArray[0]);
                if (this.parameters.presentation.type === 'google' && !this.parameters.presentation.url.includes('https://docs.google.com/presentation') ||
                    this.parameters.presentation.type === 'slides' && !this.parameters.presentation.url.includes('https://slides.com/cleverstart')
                ) {
                    this.$toasted.error(this.$i18n.t('presentations.presentations_errorLoadingPresentation'), {duration: 5000});
                    this.$router.push({name: 'dashboard'});
                    return;
                }
                this.presentation = this.parameters.presentation;
                if (this.presentation.type === 'google') {
                    this.presentation.url = this.presentation.url.replace(/pub\?/, "embed?");
                }
                if (this.presentation.type === 'file') {
                    document.getElementsByTagName("html")[0].style.cssText = "overflow: hidden";
                }
                this.isLoading = false;
            } else {
                this.$router.push({name: 'dashboard'});
            }
        },
        beforeDestroy () {
            if (this.presentation.type === 'file') {
                document.getElementsByTagName("html")[0].style.cssText = "overflow: auto";
            }
        },
        data () {
            return {
                parameters: null,
                presentation: null,
                isLoading: true,
            }
        },
        computed: {
            ...mapState({
                paramsArray: state => state.trainer.paramsArray,
                user: state => state.auth.user,
            }),
            presentationSrc () {
                if (this.presentation) {
                    return this.presentation.type === 'google' || this.presentation.type === 'slides' ? this.presentation.url : (this.$options.filters.apiFile(this.presentation.url) + DISABLE_TOOLBAR_FLAG);
                }
            },
	          toLink () {
                if (this.presentation && this.presentation.isEducationMaterial) {
                    return  { name: 'education-materials:main' }
                }
                return { name: 'create:game', query: {slug: 'Presentations'} }
	          },
	          toLinkText () {
                return (this.presentation && this.presentation.isEducationMaterial)
	                ? this.$i18n.t('common.common_navigation_goToEducationMaterials')
	                : this.$i18n.t('common.common_navigation_goToPresentations')
	          }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/sass/games/playbox.scss";

    .play-box {
        height: 100%;
        flex-direction: column;
    }

    .presentation {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
    .loading-box {
        font-size: 2rem;
        text-align: center;
    }
    .play-box__button {
        margin: .5rem 0;
        align-self: center;
    }
</style>
